import { useLocale } from 'next-intl'
import { useMemo } from 'react'

export const useFormatInvoiceDate = (
  invoiceMonth: number,
  invoiceYear: number,
  isPDF: boolean = false,
  dateShortOrLong: 'long' | 'short' = 'short'
): string => {
  const locale = useLocale()

  return useMemo(() => {
    if (!invoiceMonth || !invoiceYear) {
      return ''
    }
    const displayLocale = isPDF ? 'en-US' : locale
    const date = new Date(invoiceYear, invoiceMonth - 1, 1)
    return new Intl.DateTimeFormat(displayLocale, {
      month: dateShortOrLong,
      year: 'numeric',
    }).format(date)
  }, [invoiceMonth, invoiceYear, isPDF, dateShortOrLong, locale])
}
